import type { IBaseAttributes, TConstraints } from '@feathr/rachis';
import { Model } from '@feathr/rachis';

import { mailingConstraints } from './mailing';
import type { IMailrailSingleSendMailing } from './types';

export class MailrailSingleSendMailing extends Model<IMailrailSingleSendMailing & IBaseAttributes> {
  public readonly className = 'MailrailSingleSendMailing';

  public get constraints(): TConstraints<IMailrailSingleSendMailing & IBaseAttributes> {
    return mailingConstraints;
  }
}
